import { render, staticRenderFns } from "./TestbankExamEdit.vue?vue&type=template&id=21e54dfa&scoped=true&"
import script from "./TestbankExamEdit.vue?vue&type=script&lang=js&"
export * from "./TestbankExamEdit.vue?vue&type=script&lang=js&"
import style0 from "./TestbankExamEdit.vue?vue&type=style&index=0&id=21e54dfa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e54dfa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21e54dfa')) {
      api.createRecord('21e54dfa', component.options)
    } else {
      api.reload('21e54dfa', component.options)
    }
    module.hot.accept("./TestbankExamEdit.vue?vue&type=template&id=21e54dfa&scoped=true&", function () {
      api.rerender('21e54dfa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Room/Testbank/Exam/TestbankExamEdit.vue"
export default component.exports